<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Semanas</h4>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Buscar registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
              Buscar
            </button>
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >
            </button>
          </td>
          <td v-if="idPerfil==1">
            <button
              type="submit"
              class="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col" v-if="idPerfil==1"></th>
          <th scope="col">Fecha desde</th>
          <th scope="col">Fecha hasta</th>
          <th scope="col">Número</th>
          <th scope="col" v-if="idPerfil==1"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="semana in datosPaginados" :key="semana.idSemana">
          <td v-if="idPerfil==1">
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(semana.idSemana)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ getFormattedDate(semana.fechaDesde, "DD/MM/YYYY") }}</td>
          <td>{{ getFormattedDate(semana.fechaHasta, "DD/MM/YYYY") }}</td>
          <td>{{ semana.numeroSemana }}</td>
          <td v-if="idPerfil==1">
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteSemana(semana.idSemana)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-center">
      <nav aria-label="Page navigation example">
        <ul class="pagination d-inline-flex align-items-center">
          <!-- Botón Primera página -->
          <li
            class="page-item"
            :class="{ disabled: paginaActual === 1 }"
            @click="getFirstPage()"
          >
            <a class="page-link" href="#">Primera</a>
          </li>

          <!-- Botón Anterior -->
          <li
            class="page-item"
            :class="{ disabled: paginaActual === 1 }"
            @click="getPreviousPage()"
          >
            <a class="page-link" href="#">Anterior</a>
          </li>

          <!-- Página actual -->
          <li class="page-item active">
            <a class="page-link" href="#">{{ paginaActual }}</a>
          </li>

          <!-- Botón Siguiente -->
          <li
            class="page-item"
            :class="{ disabled: paginaActual === totalPaginas() }"
            @click="getNextPage()"
          >
            <a class="page-link" href="#">Siguiente</a>
          </li>

          <!-- Botón Última página -->
          <li
            class="page-item"
            :class="{ disabled: paginaActual === totalPaginas() }"
            @click="getLastPage()"
          >
            <a class="page-link" href="#">Última</a>
          </li>

          <li class="page-item d-flex align-items-center ms-3">
            <span class="me-1">Ir a:</span>
            <input
              type="number"
              min="1"
              :max="totalPaginas()"
              v-model.number="paginaIr"
              class="form-control me-1"
              style="width: 80px"
              @keyup.enter="irAPagina(paginaIr)"
            />
            <button
              class="btn btn-sm btn-primary"
              @click="irAPagina(paginaIr)"
              :disabled="!paginaIr || paginaIr < 1 || paginaIr > totalPaginas()"
            >
              Ir
            </button>
          </li>
        </ul>
      </nav>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idSemana" class="form-label">IdSemana</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idSemana"
                      name="idSemana"
                      v-model="datoSemana.idSemana"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaDesde" class="form-label"
                      >FechaDesde</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaDesde"
                      name="fechaDesde"
                      v-model="datoSemana.fechaDesde"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaHasta" class="form-label"
                      >FechaHasta</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaHasta"
                      name="fechaHasta"
                      v-model="datoSemana.fechaHasta"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <div class="me-auto">
              <button
                type="button"
                id="send"
                class="btn btn-light"
                data-bs-dismiss="modal"
                title="Cerrar"
              >
                <i
                  class="material-icons"
                  style="font-size: 32px; color: orangered; cursor: pointer"
                  >meeting_room</i
                >
              </button>
            </div>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarSemana"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEditSemana"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Layout from "../../components/Layout.vue";
import Footer from "../../components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "../../modules/dateFormat.js";
import { format } from "date-fns";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      semanas: [],
      datoSemana: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      paginaIr: null,
      modalWindow: true,
      idPerfil: 0
    };
  },
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, "dd/MM/yyyy");
    },
  },

  mounted() {
    this.idPerfil = window.sessionStorage.getItem("idPerfil");
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.semanas.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwsemanas").then((response) => {
        this.semanas = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
        let fin = noPagina * this.elementosPorPagina;
        this.datosPaginados = this.semanas.slice(ini, fin);
      });
    },
    getFirstPage() {
      this.paginaIr = null;
      if (this.paginaActual !== 1) {
        this.paginaActual = 1;
        this.getDataPaginaTodos(this.paginaActual);
      }
    },
    getPreviousPage() {
      this.paginaIr = null;
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      this.paginaIr = null;
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getLastPage() {
      this.paginaIr = null;
      if (this.paginaActual !== this.totalPaginas()) {
        this.paginaActual = this.totalPaginas();
        this.getDataPaginaTodos(this.paginaActual);
      }
    },
    irAPagina(numero) {
      if (numero >= 1 && numero <= this.totalPaginas()) {
        this.paginaActual = numero;
        this.getDataPaginaTodos(numero); // reemplaza por tu método de carga de datos
      }
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["fechaDesde", "fechaHasta"];
      const requiredFieldsText = ["fechaDesde", "fechaHasta"];
      return validarForm(this.datoSemana, requiredFields, requiredFieldsText);
    },
    async guardarSemana() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/semanas",
            this.datoSemana
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "Semana creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditSemana() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/semanas",
            this.datoSemana
          );
          $("#ventanaModal").modal("hide");
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "Semana creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoSemana = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idSemana) {
      this.modalWindow = true;
      if (idSemana != null) {
        api.get("/vwsemanas/" + idSemana)
          .then((resp) => {
            this.datoSemana = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    async deleteSemana(idSemana) {
      try {
        await api.delete("/semanas/" + idSemana);
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
  },
};
</script>
